/* eslint-disable */
import "../../styles/ServiciosPage.css";
import "../../styles/CircularCarousel.css";
import serviciost from "../../assets/titulos/serviciost.png";
import services from "../../assets/titles/services.png";
import CircularCarousel from "../../components/CircularCarousel";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

const ServiciosPage = () => {
  return (
    <div>
      <div className="servicios-page fade-tab">
        <div className="menu-icon-div">
          <img src={menuIcon} />
        </div>
        <div className="title-wrapper">
          <LocalizedTitleImage
            imageEn={services}
            imageEs={serviciost}
            className="title-logos"
          />
        </div>
        <div className="fade-in">
          <CircularCarousel />
        </div>
      </div>
    </div>
  );
};

export default ServiciosPage;
